export const PostCard = ({ title, imgUrl, postUrl }) => {
  return (
    <a
      href={postUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none post-card"
    >
      <div className="post-imgbx">
        <img
          src={imgUrl}
          alt={title}
          className="post-cover"
          loading="lazy"
          decoding="async"
        />
        <div className="post-txtx">
          <h4>{title}</h4>
        </div>
      </div>
    </a>
  );
};
